export const MOBILE_TOOLBAR = 'mobile-toolbar';
